import {
  startOfMonth,
  startOfQuarter,
  startOfYear,
  endOfMonth,
  endOfQuarter,
  endOfYear,
} from 'date-fns';

export function GenerateDateByCode(code: string) {
  const today = new Date(new Date().setHours(0, 0, 0, 0));
  switch (code) {
    case 'startOfITD':
      return new Date('2000/01/01');
    case 'startOfMonth':
      return startOfMonth(today);
    case 'startOfQuarter':
      return startOfQuarter(today);
    case 'startOfYear':
      return startOfYear(today);
    case 'endOfMonth':
      return endOfMonth(today);
    case 'endOfQuarter':
      return endOfQuarter(today);
    case 'endOfYear':
      return endOfYear(today);
    case 'today':
      return today;
  }
}
